import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { ChequeCultureLegacy } from "../../legacyforms/ChequeCultureLegacy";
import { ClapService } from "../../../service/ClapService";
import { LinkProviderService } from "../../../service/LinkProviderService";
import "../../../layout/styles/inline-cgos.css";
import '../cesu/FormulaireCesu.scss';
import {Accordion, AccordionTab} from "primereact/accordion";


import { useDispatch, useSelector } from "react-redux";
import {
  setFiche,
  setIban,
  setOptJustificatif,
  setCesuMultiMontantTaux
} from "../../../store/actions/actionSociale";
import { ActionSocialeService } from "../../../service/ActionSocialeService";
import { AgentService } from "../../../service/AgentService";
import { ChequeCultureService } from "../../../service/ChequeCultureService";

export const CesuMultiNoticeInformation = ({ mode, hiddenNoticeButton, onConfirm, displayErrors }) => {
  const errors = {
    dod: 1,
    statut: 2,
    qf: 2,
    iban: 3,
    pac: 4,
    exercice:5,
    droits:6,
    siDossierValide:7
  };

  const user = useSelector((state) => state.usager.user);
  const actionSociale = useSelector((state) => state.actionSociale);
  const [currentActionSociale, setCurrentActionSociale] = useState({});
  const [baremes, setBaremes] = useState([]);
  const [baremesParTranche, setBaremesParTranche] = useState({});

  const [cesuMultiTaux,setCesuMultiTaux] = useState({});

  const [montantTauxPartiel, setMontantTauxPartiel] = useState({});
  const [montantTauxTotal, setMontantTauxTotal] = useState({});

  const [valParticipation, setValParticipation] = useState(0);
  const [valMaxParticipation, setValMaxParticipation] = useState(0);

  const [displayBasic, setDisplayBasic] = useState(false);
  const [isJustificatifRequis, setIsJustificatifRequis] = useState();

  const [displayError, setDisplayError] = useState([]);
  const [activeIndex, setActiveIndex] = useState([]);

  const [hiddenButton, hideButton] = useState(hiddenNoticeButton);
  const dispatch = useDispatch();
  const history = useHistory();

  const actionSocialeService = new ActionSocialeService();
  const clapService = new ClapService();
  const agentService = new AgentService();
  const chequeCultureService = new ChequeCultureService();

  const linkService = new LinkProviderService();

  const  textAdressezVous="Pour en savoir plus ou si vous pensez qu'il y a une erreur, adressez-vous à votre ";


  useEffect(() => {
        getIsJustificatifRequis();
        getCurrentActionSociale();
      setActiveIndex([0]);
  }, []);
  
  useEffect(() => {
    dispatch(setOptJustificatif(isJustificatifRequis));
  }, [isJustificatifRequis]);


  useEffect(() => {
    dispatch(setCesuMultiMontantTaux(cesuMultiTaux));
 }, [cesuMultiTaux]);





  const getFiche =  (actionSocial) => {
      agentService.getFicheAgent(user.numCgos, actionSocial.exercice).then((fiche) => {
          getBaremes(actionSocial,fiche.data);
      });
   }

  const getBaremes = async (actionSocial,fiche) => {
          const bareme = {
            exercice: actionSocial.exercice
          };

          try {
            const { data } = await clapService.getBaremesCesuMulti(bareme);
            setBaremes(data);
            const map = {};

            data.forEach(i => {
              const [borneMin, borneMax] = i.tranche.split("-").map(Number);
              const montant = Number(i.montant);
            
              if (!map[montant]) map[montant] = [];
            
              map[montant].push({
                borneMin,
                borneMax,
                taux: Number(i.tauxParticipation),
                montant
              });
            });
            
            Object.keys(map).forEach(key => {
              map[key].sort((a, b) => a.borneMin - b.borneMin);
            });
          
            const montants = Object.keys(map).map(Number).sort((a, b) => a - b);
            let partielBareme=map[montants[0]];
            let totalBareme=map[montants[montants.length - 1]];
            setBaremesParTranche({
              partiel: partielBareme, 
              total: totalBareme
            });
            //get partiel taux + montant
            let montantTauxPartiel=getMontantTaux(partielBareme,fiche.quotientFamilial);
            setMontantTauxPartiel(montantTauxPartiel);
             //get total taux + montant
             let montantTauxTotal=getMontantTaux(totalBareme,fiche.quotientFamilial);
            setMontantTauxTotal(montantTauxTotal);
            setCesuMultiTaux({"tauxPartiel":montantTauxPartiel,"tauxTotal":montantTauxTotal});
          } catch (error) {
            console.log(error);
          }
        };

  const getMontantTaux = (bareme,qf) => {
    if (qf == null) return { taux: bareme[bareme.length-1].taux, montant: bareme[bareme.length-1].montant };
    const found = bareme.find(t => qf >= t.borneMin && qf <= t.borneMax);
    if (!found) return { taux: bareme[bareme.length-1].taux, montant: bareme[bareme.length-1].montant };
  
    return {
      taux: found.taux,
      montant: found.montant
    };
  }       

  const getCurrentActionSociale = () => {
    Object.values(actionSociale.listActionsSociale).forEach((as) => {
      if (
        as.codeActionSociale === actionSociale.cas &&
        as.exercice === actionSociale.exercice
      ) {
        setCurrentActionSociale(as);
        getFiche(as)
        return;
      }
    });
  };


  const getIsJustificatifRequis = async () => {
    try {
      const { data } = await chequeCultureService.getJustificatifRequis();
      setIsJustificatifRequis(data);
    } catch (error) {
      console.log(error);
    }
  };



  const nextStep = () => {
    actionSocialeService.persistState(actionSociale);
    onConfirm(false);
    hideButton(true);
  };


  return (
    <div className="grid">
      <ChequeCultureLegacy />
      <div className="col-12 mx-auto">
        <div className="no_shadow_no_border card " style={{ display: !displayBasic ? "block" : "none" ,fontSize: "10.0pt",fontFamily: "Tahoma, sans-serif"}}>
          <Accordion activeIndex={[0,1,2,3,4,5,6,7]} multiple onTabChange={(e) => setActiveIndex(e.index)} >
            <AccordionTab headerClassName="cgos-h3" header=" Quel est le service rendu ?">
            <p className="cld-p">
              <span>
              Le CESU Multiservices, financé en partie par le C.G.O.S, permet de régler des prestations de services à la personne à domicile (aide à domicile, ménage/repassage, petits travaux du quotidien…).

                <br/><br/>
                <b>Validité</b>
                <br/>
                Valable jusqu’au 31 janvier de l’année suivant sa date d'émission et utilisable dans toute la france et dans les DROM. À l’échéance, un échange peut être demandé <b>directement auprès d’UPCOOP </b> pour obtenir des titres de même valeur (échange possible une seule fois).
                <br/><br/>
              </span>
            </p>

            <p className="notice">
              <b>Deux formats sont proposés</b>
              <br/><br/>
              <b>e-CESU Multiservices</b><br/>
              Ce format digital permet un paiement en ligne au centime près sans risque de perte ou de vol.<br/><br/>
              <b>CESU Multiservices papier</b><br/>
              Le format papier permet de payer les intervenants qui n’acceptent pas encore le paiement avec le format digital.
              <br/>
              Ce format permet permet également de payer en ligne. Il suffit de gratter le code sur le chèque et de créer un compte sur UPCOOP.​
              <br/><br/>
            </p> 
            

            <br/>
            <div class="astuce-box-warning">
              <strong>Comment choisir le bon format ?</strong><br/>
              Vérifiez avant de commander si la structure ou la personne employée accepte le format papier ou le format digital.
              <br/>
              (La personne employée doit être affiliée CR-CESU et avoir un code NAN).
            </div>
            <br/><br/>

            </AccordionTab>
            <AccordionTab headerClassName="cgos-h3" header="Suis-je concerné ?">
              <p className="cld-p">
                <span>
                
                Oui si je suis,
                <br/><br/>
                <ul>
                  <li>un <b>agent en activité</b> (titulaire, stagiaire, contractuel, emploi aidé, apprenti),</li>
                  <li>un <b>retraité</b> (si mes droits ont été ouverts lorsque vous j'étais en activité).</li>
                  <li>un <b>agent en congés parental à 100%</b> disposant d'une décision administrative de mon établissement.</li>
                  <li>Un <b>ayant droit</b> ou un <b>tuteur</b>.</li>
                </ul>
                </span>
              </p>
            </AccordionTab>

            <AccordionTab headerClassName="cgos-h3" header="Quand et à quelles conditions puis-je faire une demande ?">
              <p className="cld-p">
                <span>
                <p>
                Je dois d’abord envoyer mon dossier C.G.O.S. pour l’année (N) avant toute demande.
                <br/>
                Ma demande est étudiée une fois mes droits ouverts pour cette même année.
                <br/><br/>
                <b>Montant de la commande</b>
                <br/>
                Je peux demander le montant annuel maximum en 1 ou 2 fois :
                 <ul>
                    <li>En 1 fois : je reçois tout, pas de seconde commande possible.</li>
                    <li>En 2 fois : je reçois la moitié à chaque commande.</li>
                 </ul>
                 <br/>
                 Les CESU Multiservices sont versés dans la limite des budgets disponibles (demandes refusées au-delà).
                </p>
                </span>
              </p>
            </AccordionTab>
            <AccordionTab headerClassName="cgos-h3" header="Comment et quand recevrais-je mes CESU Multiservices ?" disabled={false}>
              <p className="cld-p">
                <span>
                  <p>Le C.G.O.S. passe commande auprès de UPCOOP une fois par mois. Livraison au plus tard à la fin du mois suivant la commande du C.G.O.S.</p>
                  <br/>
                  <p>Les CESU Multiservices papier seront envoyés directement à mon domicile.</p>
                  <p>Les e-CESU Multiservices seront crédités sur mon compte en ligne UPCOOP (les identifiants me seront envoyés par email).</p>
                 
                </span>
              </p>
            </AccordionTab>

            <AccordionTab headerClassName="cgos-h3" header="Comment est calculée la prestation ?" disabled={false}>
              <p className="cld-p">
                <span>
                La participation du C.G.O.S et le montant à payer par carte bancaire dépendent de mon quotient familial C.G.O.S.​
                </span>
              </p>

              {!((displayError.includes(errors.exercice) || displayError.includes(errors.droits) || displayError.includes(errors.dod) || displayError.includes(errors.siDossierValide)) ) && (
                  <table className="cld-table-2">
                <thead>
                  <tr>
                    <th style={{backgroundColor: '#dddcdd', color: '#000'}}>Mon quotient familial</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {actionSociale.fiche.quotientFamilial == null? "non connu" : actionSociale.fiche.quotientFamilial.toString().replace('.', ',')}
                    </td>
                  </tr>
                </tbody>
              </table>
              
              )}
              <br/><br/>
              <p className="cld-p">
                <span>
                Tableau des montants à payer par carte bancaire.
                </span>
              </p>
              <table className="cld-table">
                <thead>
                  <tr>
                    <th style={{backgroundColor: '#eaf8fb', color: '#000'}}>Tranches de quotient familial</th>
                    <th style={{backgroundColor: '#eaf8fb', color: '#000'}}>Commande de 150 € <br/>2 commandes par an</th>
                    <th style={{backgroundColor: '#eaf8fb', color: '#000'}}>Commande de 300 € <br/>1 commande par an</th>
                  </tr>
                </thead>
                <tbody>
                  {baremesParTranche.total?.map((el, i) => {
                    let borne = "";
                    let listTotal = baremesParTranche.total;
                    let listPartiel = baremesParTranche.partiel;
                    if (i >= 0 && i < listTotal.length - 1) {
                      const borneToNumber = Number(listTotal[i + 1].borneMin).toFixed(0);
                      borne = `de ${el.borneMin} à ${borneToNumber}`;
                    } else {
                      borne = `supérieur à ${Number(el.borneMin).toFixed(
                        0
                      )} ou non connu`;
                    }
                    return (
                      <tr key={i}>
                        <td>{borne}</td>
                        <td>
                          {listPartiel?.[i]
                            ? Number(listPartiel[i].montant) * (1 - Number(listPartiel[i].taux) / 100)
                            : 0
                          } €
                        </td>
                        <td>{Number(el.montant)*(1-Number(el.taux)/100)} €</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <br/><br/>
            </AccordionTab>

            {isJustificatifRequis && (
            <AccordionTab headerClassName="cgos-h3" header="Quel(s) document(s) dois-je préparer ?" disabled={false}>
                <div class="card-justificatif" style={{backgroundColor: '#fff2d6', borderLeft: '5px solid #b38600'}}>
                  <div class="card-justificatif-body">
                    <div class="card-justificatif-img" style={{width: "13%", marginRight: "1%"}}>
                      <img src="/assets/image/DOC-gris.png" title="Bulletin de paie ou attestation de travail" alt="Icon Bulletin de paie ou attestation de travail"/>
                    </div>
                    <div class="card-justificatif-txt-container" style={{width: "85%", color: 'black', fontFamily: 'sans-serif'}}>
                      <div class="card-justificatif-titre pt-2">
                        <span style={{fontSize: '10pt', fontFamily: 'Tahoma, sans-serif'}}>
                          Justificatif de présence en établissement
                        </span>
                      </div>
                      <div class="card-justificatif-description">
                        <span style={{fontSize: '9pt', fontFamily: 'Tahoma, sans-serif'}}>
                          Bulletin de paie ou attestation de travail de moins d’un mois ou décision administrative de congés parental à 100%.
                          <br></br>
                          <br></br>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

              <div className="tutorial">
                <img className="tutorial-image" src="/assets/icon_youtube.png" title="Icone youtube" alt="icon youtube"/>{" "}
                <a
                  target="_blank"
                  href="https://www.youtube.com/watch?v=rQzzWn7Yz-o"
                >
                  <span
                    style={{
                      color:"black",
                      textDecoration: "underline"
                    }}
                  >
                    # TutorielCGOS - Comment scanner un document
                  </span>
                </a>
              </div>
            </AccordionTab>)}



            <AccordionTab headerClassName="cgos-h3" header="Les grandes étapes de la demande" disabled={false}>
              <p className="cld-c">
                <ol>
                  <span>
                    <li style={{marginBottom: '1%'}}>
                    Je choisis le format : papier ou digital et j’envoie ma demande via l’Espace agent.
                    </li>
                    <li style={{marginBottom: '1%'}}>
                    J’attends la validation : le C.G.O.S. valide ou refuse.
                    </li>
                    <li style={{marginBottom: '1%'}}>
                    Dès validation par le C.G.O.S., je reçois un lien pour payer avec ma carte bancaire.
                    </li>
                    <li style={{marginBottom: '1%'}}>
                    Une fois payés, les CESU Multiservices sont fabriqués dans le mois suivant.
                    </li>
                    <li style={{marginBottom: '1%'}}>
                    Je les reçois au plus tard à la fin du mois suivant la validation du C.G.O.S.
                    </li>

                  </span>
                </ol>
              </p>

            </AccordionTab>
          </Accordion>
          
          <div class="astuce-box-success mt-3">
            <strong>INFO</strong> : Demander cette prestation prend <strong>moins de 2 minutes</strong>
          </div>
          {!hiddenButton && (
            <div>
              <br></br>
              <div className="next-button-wrapper">
                 { displayErrors.length > 0
                                 ? <button type="button" className="btn_submit_modal" disabled style={{ pointerEvents: "none" }}> DEMANDER CETTE PRESTATION </button>
                                 : <button type="button" className="btn_submit_modal" style={{borderColor: "#999898"}} onClick={nextStep}> DEMANDER CETTE PRESTATION </button>}
              </div>
              <br></br>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
